import { AppProps } from 'next/app';
import { AuthProvider } from '../contexts/AuthContext';
import { NotificationProvider } from '../contexts/NotificationContext';
import '../styles/globals.css';
import Head from "next/head";
import Header from "../components/Header";
import InstallPrompt from "../components/InstallPrompt";
import { SpotifyPlaybackProvider } from '../contexts/SpotifyPlaybackContext';
import { useRouter } from 'next/router';

function App({ Component, pageProps }: AppProps) {
  const router = useRouter();
  return (
      <AuthProvider>
        <SpotifyPlaybackProvider>
          <NotificationProvider>
          <Head>
            <title>Music Man</title>
            <meta name="description" content="Explore, organize, and resume your Spotify album listening." />
            <meta name="viewport" content="width=device-width, initial-scale=1, viewport-fit=cover" />
            <meta name="theme-color" content="#111827" />
            <meta name="application-name" content="Music Man" />
            <meta name="mobile-web-app-capable" content="yes" />
            <meta name="apple-mobile-web-app-capable" content="yes" />
            <meta name="apple-mobile-web-app-status-bar-style" content="black-translucent" />
            <link rel="manifest" href="/manifest.json" />
            <link rel="icon" href="/icons/app-icon.svg" type="image/svg+xml" />
            <link rel="apple-touch-icon" href="/icons/apple-touch-icon.png" />
          </Head>
          <div className="app-shell">
            <Header />
            <main id="main-content" className={`app-content ${router.pathname === '/player' ? 'player-view' : 'compact-view'}`}>
              <Component {...pageProps} />
            </main>
            <InstallPrompt />
          </div>
          </NotificationProvider>
        </SpotifyPlaybackProvider>
      </AuthProvider>
  );
}

export default App;
